import React from 'react';
import CSSModules from 'react-css-modules';
import * as PropTypes from 'prop-types';

import Title from '../../../Drawer/Title';
import Icon from '../../../Icon';
import styles from './index.styl';

function EmptyBlock({ title, text, icon, size, className }) {
  return (
    <div styleName="root" className={className}>
      <Icon name={icon} size={size} className="flex-shrink-0" />
      <div styleName="content">
        <Title
          text={title}
          styleName="title"
          className="f-12 g-color--accent"
        />
        <p styleName="text">{text}</p>
      </div>
    </div>
  );
}

EmptyBlock.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  icon: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string,
};

EmptyBlock.defaultProps = {
  size: 60,
};

export default CSSModules(EmptyBlock, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/EmptyBlock/index.jsx